import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { LocaleService } from '@app/system/services/locale.service';


export interface LeaderBoardCard {
	title: string;
	points?: number;
	badge?: string;
	userThumbnail?: string;
	rank?: number;
	shortInfo?: Array<any>;
	ratingType?: 'round' | 'capsule',
	background?: boolean;
}

@Component({
	selector: 'app-leaderboard-card',
	templateUrl: './leaderboard-card.component.html',
	styleUrls: ['./leaderboard-card.component.scss']
})
export class LeaderboardCardComponent implements OnInit {


	@Input('record') leaderCard: LeaderBoardCard;
	@Output() detail: any = new EventEmitter();

	constructor(
		public locale: LocaleService,
		public gfService: GlobalFunctionService
	) { }

	ngOnInit(): void {
	}

	info() {
		if (navigator.onLine) {
			this.detail.emit(true);
		}
	}

}
